export const accessCode =
	{
        AccessGranted: 101,
		UserNotFound: 102,
        AccessExists: 103,
        HasUsedTrial: 104,
        Error: 105
    }